import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '@/lib/utils'

const PopoverBase = PopoverPrimitive.Root

const PopoverTriggerBase = PopoverPrimitive.Trigger

const PopoverAnchorBase = PopoverPrimitive.Anchor

const PopoverCloseBase = PopoverPrimitive.Close

const PopoverContentBase = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { container?: HTMLElement | null }
>(({ className, align = 'center', sideOffset = 4, container, ...props }, ref) => (
  <PopoverPrimitive.Portal container={container}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-[999999] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-lg outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContentBase.displayName = PopoverPrimitive.Content.displayName

// --- uiv2: conditional Intui swap (build-time resolved by Vite) ---
import {
  IntuiPopover,
  IntuiPopoverTrigger,
  IntuiPopoverContent,
  IntuiPopoverClose,
  IntuiPopoverAnchor,
} from '@/components/intueri/IntuiPopover'

const _uiv2 = import.meta.env.VITE_UIV2 === 'true'
const Popover = _uiv2 ? IntuiPopover : PopoverBase
const PopoverTrigger = _uiv2 ? IntuiPopoverTrigger : PopoverTriggerBase
const PopoverContent = _uiv2 ? (IntuiPopoverContent as typeof PopoverContentBase) : PopoverContentBase
const PopoverAnchor = _uiv2 ? IntuiPopoverAnchor : PopoverAnchorBase
const PopoverClose = _uiv2 ? IntuiPopoverClose : PopoverCloseBase

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose }
